<template>
  <div>
    <div class="row">
      <div class="col-12">
        <Card body-classes="p-0" class="mb-5 bg-white shadow-sm">
          <template v-slot:header>
            <div class="d-flex align-items-center justify-content-between p-2">
              <div class="d-flex align-items-center">
                <div class="bg-primary-light p-2 rounded-2 me-3">
                  <vue-feather type="edit" class="d-flex justify-content-center align-content-center" stroke="#652aa3" size="24"></vue-feather>
                </div>
                <h4 class="mb-0 fw-bold">Edit Employee</h4>
              </div>
            </div>
          </template>
          <div class="col-md-12 p-4">
            <form @submit.prevent="">
              <!-- Personal Information Section -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="user" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Personal Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-3">
                      <label for="employee_no" class="form-label fw-bold">Employee No:</label>
                      <input type="text" class="form-control" v-model="employee.employee_no" readonly>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="first_name" class="form-label fw-bold">First Name:</label>
                      <input type="text" class="form-control" v-model="employee.first_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="middle_name" class="form-label fw-bold">Middle Name:</label>
                      <input type="text" class="form-control" v-model="employee.middle_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="last_name" class="form-label fw-bold">Last Name:</label>
                      <input type="text" class="form-control" v-model="employee.last_name">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="id_number" class="form-label fw-bold">ID Number:</label>
                      <input type="text" class="form-control" v-model="employee.id_number">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="phone" class="form-label fw-bold">Phone:</label>
                      <input type="text" class="form-control" placeholder="0712333555" v-model="employee.phone">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="email" class="form-label fw-bold">Email:</label>
                      <input type="text" class="form-control" v-model="employee.email">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="gender" class="form-label fw-bold">Gender:</label>
                      <select data="" type="text" class="form-select" v-model="employee.gender">
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="dob" class="form-label fw-bold">Date of Birth:</label>
                      <input type="date" class="form-control" v-model="employee.dob">
                    </div>
                    <div class="form-group col-md-6">
                      <label for="address" class="form-label fw-bold">Address:</label>
                      <input type="text" class="form-control" v-model="employee.address">
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Employment Information -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="briefcase" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Employment Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-3">
                      <label for="employment_status" class="form-label fw-bold">Employment Terms:</label>
                      <select data="" type="text" class="form-select" v-model="employee.tos">
                        <option value="Permanent">Permanent</option>
                        <option value="Contract">Contract</option>
                        <option value="Consultant">Consultant</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="salary" class="form-label fw-bold">{{ salaryText }}:</label>
                      <input type="number" class="form-control" v-model="employee.salary">
                    </div>
                    <div class="form-group col-md-3">
                      <label for="employment_date" class="form-label fw-bold">Employment Date:</label>
                      <input type="date" class="form-control" v-model="employee.employment_date">
                    </div>
                    <div v-if="employee.tos !== 'Permanent'" class="form-group col-md-3">
                      <label for="termination_date" class="form-label fw-bold">Termination Date:</label>
                      <input type="date" class="form-control" v-model="employee.termination_date">
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Deductions -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="minus-circle" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Deductions</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="paye" v-model="employee.paye">
                        <label class="form-check-label fw-bold" for="paye">Deduct PAYE</label>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="nhif" v-model="employee.nhif">
                        <label class="form-check-label fw-bold" for="nhif">Deduct SHIF</label>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="nssf" v-model="employee.nssf">
                        <label class="form-check-label fw-bold" for="nssf">Deduct NSSF</label>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="housing" v-model="employee.housing">
                        <label class="form-check-label fw-bold" for="housing">Housing Levy</label>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="nita" v-model="employee.nita">
                        <label class="form-check-label fw-bold" for="nita">Deduct NITA</label>
                      </div>
                    </div>
                    <div class="form-group col-md-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="email_payslip" v-model="employee.email_payslip">
                        <label class="form-check-label fw-bold" for="email_payslip">Email Payslip</label>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Work Information -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="layers" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Work Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-4">
                      <label for="department" class="form-label fw-bold">Department:</label>
                      <select data="" type="text" class="form-select" v-model="employee.department_id">
                        <option v-for="department in departments" :key="department.id" :value="department.id">{{department.name}}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="designation" class="form-label fw-bold">Designation:</label>
                      <select data="" type="text" class="form-select" v-model="employee.designation_id">
                        <option v-for="designation in designations" :key="designation.id" :value="designation.id">{{designation.name}}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="work_station" class="form-label fw-bold">Work Station:</label>
                      <select data="" type="text" class="form-select" v-model="employee.work_station_id">
                        <option v-for="station in stations" :key="station.id" :value="station.id">{{station.name}}</option>
                      </select>
                    </div>
                  </div>
                </Card>
              </div>

              <!-- Financial Information -->
              <div class="mb-4">
                <div class="d-flex align-items-center mb-3">
                  <vue-feather type="credit-card" stroke="#652aa3" size="18" class="me-2"></vue-feather>
                  <h5 class="mb-0">Financial Information</h5>
                </div>
                <Card class="shadow-sm border-0 mb-3">
                  <div class="row g-3 p-3">
                    <div class="form-group col-md-4">
                      <label for="pin_no" class="form-label fw-bold">PIN No:</label>
                      <input type="text" class="form-control" v-model="employee.details.pin_no">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="nssf_no" class="form-label fw-bold">NSSF No: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" v-model="employee.details.nssf_no">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="nhif_no" class="form-label fw-bold">SHIF No: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" v-model="employee.details.nhif_no">
                    </div>
                    <div class="form-group col-md-4">
                      <label for="bank_name" class="form-label fw-bold">Bank Name: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" list="bankOptions" id="bankName" v-model="employee.details.bank_name" @change="clearBranch" placeholder="Type to search...">
                      <datalist id="bankOptions">
                        <option v-for="bank in bankNames.banks" :key="bank" :value="bank"></option>
                      </datalist>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="branch_name" class="form-label fw-bold">Branch Name: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" list="branchOptions" id="branchName" v-model="employee.details.branch_name" placeholder="Type to search...">
                      <datalist id="branchOptions">
                        <option v-for="branch in bankBranches" :key="branch" :value="branch"></option>
                      </datalist>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="account_no" class="form-label fw-bold">Account Number: <span class="text-black-50 fst-italic small">(optional)</span></label>
                      <input type="text" class="form-control" placeholder="Account number" v-model="employee.details.account_no">
                    </div>
                  </div>
                </Card>
              </div>
            </form>
          </div>
          <div class="p-4 bg-light border-top">
            <div class="d-flex justify-content-center">
              <button class="btn btn-dark text-uppercase me-4 px-4 py-2 shadow" @click="$router.go(-1)">
                <vue-feather type="arrow-left" size="16" class="me-2"></vue-feather>
                Back
              </button>
              <button v-if="profile.role !== 'user'" class="btn btn-primary text-uppercase px-4 py-2 shadow" @click="submitForm">
                <vue-feather type="save" size="16" class="me-2"></vue-feather>
                Submit
              </button>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import employeeService from "@/api/employeeService";
import departmentService from "@/api/departmentService";
import stationService from "@/api/stationService";
import designationService from "@/api/designationService";
import {decrypt} from "@/utils/crypto";
import bankService from "@/api/bankService";
import loadingButton from "@/utils/loadingButton";
import VueFeather from 'vue-feather';

export default {
  name: "EditEmployee",
  components: {
    VueFeather
  },

  data() {
    return {
      profile: {},
      departments: [],
      stations: [],
      designations: [],
      employee: {
        details: {},
      },
      bankNames: {
        banks: [],
        branches: {}
      },
      bankBranches: []
    }
  },

  methods: {
    submitForm: async function (e) {
      loadingButton(e)
      await employeeService.updateEmployee(this.employee, this.$route.params.id)
      loadingButton(e, false)
    },
    clearBranch: function () {
      this.employee.details.branch_name = ''
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    this.employee = await employeeService.getEmployee(this.$route.params.id)
    this.departments = await departmentService.getDepartments()
    this.designations = await designationService.getDesignations()
    this.stations = await stationService.getStations()
    this.employee.paye = !!this.employee.paye
    this.employee.nhif = !!this.employee.nhif
    this.employee.nssf = !!this.employee.nssf
    this.employee.housing = !!this.employee.housing
    this.employee.nita = !!this.employee.nita
    this.employee.email_payslip = !!this.employee.email_payslip
    this.bankNames = await bankService.getBankNames()
    if (this.employee.details.bank_name !== null) {
      this.bankBranches = this.bankNames.branches[this.employee.details.bank_name]
    }
  },

  computed: {
    salaryText: function () {
      if (this.employee.tos === 'Consultant') {
        return 'Salary incl. VAT'
      } else {
        return 'Salary'
      }
    }
  },

  watch: {
    'employee.details.bank_name': function () {
      this.bankBranches = this.bankNames.branches[this.employee.details.bank_name]
    },
    'employee.tos': function () {
      let checked = this.employee.tos !== 'Consultant' && this.employee.tos !== 'Casual';
      document.querySelectorAll('input[type=checkbox]').forEach(el => el.checked = checked);
    }
  },
}
</script>

<style scoped>

</style>
